export const Auth = {
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:e219ebd8-ffbf-41ac-abda-978ecce76c7e',
  userPoolId: 'eu-central-1_JPogeUzMw',
  userPoolWebClientId: '6vlkg4opsv103jt4pjd7cjh3vs',
};
